import "./DeleteModal.css";
import { Box } from "@mui/material";
import Title from "../title/Title";
import {
  PrimaryButton,
  SecondaryButton,
} from "../buttonComponent/ButtonComponent";
import ModalCloseButton from "./ModalCloseButton";
import StopIcon from "./img/agencySelector.svg";
import { formatCapitalize } from "../../config/utilities/formatCapitalize";
import Text from "../text/Text";
import ArrowRight from "./img/arrowRight.svg";
import RadioButton from "../radioButton/RadioButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 450,
  maxWidth: "90vw",
  bgcolor: "#FFFFFF",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  p: 0,
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
};

const ConfirmStopModal = ({
  initialInput,
  input,
  setInput,
  studentsWithStops,
  loading,
  isOpen,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  function getChanges(initial, current) {
    const changes = {};
    const skipKeys = ["associatedChilds", "address", "updateScope"];

    for (const key in current) {
      if (skipKeys.includes(key)) continue;

      if (Array.isArray(current[key])) {
        if (JSON.stringify(current[key]) !== JSON.stringify(initial[key])) {
          changes[key] = {
            from: initial[key],
            to: current[key],
          };
        }
      } else if (typeof current[key] === "object" && current[key] !== null) {
        const nestedChanges = getChanges(initial[key] || {}, current[key]);
        if (Object.keys(nestedChanges).length > 0) {
          changes[key] = nestedChanges;
        }
      } else if (current[key] !== initial[key]) {
        changes[key] = { from: initial[key], to: current[key] };
      }
    }

    return changes;
  }

  const changes = getChanges(initialInput, input);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedInput = { ...input, [name]: value };
    setInput(updatedInput);
  };

  return (
    <div className="modal-backdrop">
      <Box sx={style}>
        <div>
          <div className="modal-header-content">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <img loading="lazy" src={StopIcon} alt="invite-users-icon" />
              <ModalCloseButton onClick={onClose} />
            </div>
            {Object.keys(changes).length > 0 && (
              <>
                <Title
                  title="Confirm Stop Changes"
                  deleteSubtitle
                  titleSize="1.125rem"
                  subtitleSize="0.875rem"
                  subtitle="By confirming, the changes below will be reflected for this stop:"
                  gap="0rem"
                  lineHeight="1.75rem"
                />

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.75rem",
                  }}
                >
                  {Object.entries(changes).map(([field, diff]) => {
                    return (
                      <div
                        key={field}
                        style={{
                          border: "1px solid #E4E7EC",
                          borderRadius: "0.5rem",
                          padding: "0.75rem 1rem",
                          backgroundColor: "#F9FAFB",
                          minWidth: 400,
                          maxWidth: "80vw",
                        }}
                      >
                        {diff.from !== undefined && diff.to !== undefined ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                            }}
                          >
                            <Text
                              size="0.9rem"
                              color="#101828"
                              weight="600"
                              text={`${formatCapitalize(field)}:`}
                            />

                            <Text
                              size="0.875rem"
                              color="#B42318"
                              weight="500"
                              text={String(diff.from) || "N/A"}
                            />
                            <img
                              src={ArrowRight}
                              alt="arrow right"
                              style={{ width: 16, height: 16 }}
                            />
                            <Text
                              size="0.875rem"
                              color="#027A48"
                              weight="500"
                              text={String(diff.to) || "N/A"}
                            />
                          </div>
                        ) : (
                          <>
                            {Object.entries(diff).map(
                              ([nestedField, nestedDiff]) => {
                                if (
                                  !nestedDiff ||
                                  typeof nestedDiff !== "object"
                                )
                                  return null;

                                return (
                                  <div
                                    key={nestedField}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "0.5rem",
                                    }}
                                  >
                                    <Text
                                      size="0.9rem"
                                      color="#101828"
                                      weight="600"
                                      text={`${formatCapitalize(field)}:`}
                                    />
                                    <Text
                                      size="0.875rem"
                                      color="#B42318"
                                      weight="500"
                                      text={
                                        Array.isArray(nestedDiff.from)
                                          ? nestedDiff.from
                                              .map((v) => v.toFixed(2))
                                              .join(", ")
                                          : typeof nestedDiff.from === "number"
                                          ? nestedDiff.from.toFixed(2)
                                          : String(nestedDiff.from ?? "N/A")
                                      }
                                    />
                                    <img
                                      src={ArrowRight}
                                      alt="arrow right"
                                      style={{ width: 16, height: 16 }}
                                    />
                                    <Text
                                      size="0.875rem"
                                      color="#027A48"
                                      weight="500"
                                      text={
                                        Array.isArray(nestedDiff.to)
                                          ? nestedDiff.to
                                              .map((v) => v.toFixed(2))
                                              .join(", ")
                                          : typeof nestedDiff.to === "number"
                                          ? nestedDiff.to.toFixed(2)
                                          : String(nestedDiff.to ?? "N/A")
                                      }
                                    />
                                  </div>
                                );
                              }
                            )}
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
            {studentsWithStops.length > 0 && (
              <>
                <Title
                  title="Student Stop Conflict Detected"
                  deleteSubtitle
                  titleSize="1.125rem"
                  subtitleSize="0.875rem"
                  gap="0rem"
                  lineHeight="1.75rem"
                >
                  By confirming, these students will be{" "}
                  <strong>reassigned</strong> to this stop:
                </Title>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.35rem",
                  }}
                >
                  {studentsWithStops.map((child, index) => (
                    <div
                      key={child.id}
                      style={{
                        fontSize: "0.875rem",
                        lineHeight: "1.5rem",
                      }}
                    >
                      {index + 1}. <strong>{child.name}</strong>
                      {` ${child.class ? `(${child.class}) ` : " "}- ${
                        child.stopName
                      }`}
                    </div>
                  ))}
                </div>
              </>
            )}
            <>
              <Title
                title="Schedule Updates"
                deleteSubtitle
                titleSize="1.125rem"
                subtitleSize="0.875rem"
                gap="0rem"
                lineHeight="1.75rem"
              >
                How would you like these changes to affect schedules?
              </Title>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.35rem",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "1rem",
                  }}
                >
                  <RadioButton
                    name="updateScope"
                    value="none"
                    text="None"
                    onChange={(e) => handleInputChange(e)}
                    checked={input.updateScope === "none"}
                  />
                  <RadioButton
                    name="updateScope"
                    value="today"
                    text="Today"
                    onChange={(e) => handleInputChange(e)}
                    checked={input.updateScope === "today"}
                  />
                  <RadioButton
                    name="updateScope"
                    value="future"
                    text="Future"
                    onChange={(e) => handleInputChange(e)}
                    checked={input.updateScope === "future"}
                  />
                  <RadioButton
                    name="updateScope"
                    value="both"
                    text="Both"
                    onChange={(e) => handleInputChange(e)}
                    checked={input.updateScope === "both"}
                  />
                </div>
                <Text
                  size="0.75rem"
                  color="#667085"
                  weight="400"
                  text="“Both” syncs today’s schedule and all future schedules."
                />
              </div>
            </>
          </div>
          <div className="button-container-delete">
            <SecondaryButton
              label="Cancel"
              width="190px"
              imageIcon={false}
              onClickFunction={onClose}
            />
            <PrimaryButton
              loading={loading}
              label="Confirm"
              width="190px"
              disable={false}
              onClickFunction={onConfirm}
            />
          </div>
        </div>
      </Box>
    </div>
  );
};

export default ConfirmStopModal;
